import API_ENDPOINTS from '../../endpoints/apiEndpoints';
import apiClient from '../../apiClient';
import { BaseResponse } from '../UtilsInterface';
import { InquiryData, InquiryResponse } from '../InquiryInterfaces';

// 구매자 문의하기 서비스 정의
const SellerInquiryService = {
  // 문의 이력 조회
  getInquiriesList: async (
    page: number,
    size: number
  ): Promise<InquiryResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_seller_inquiry_list(page, size)
      );
      return response.data;
    } catch (error) {
      console.error('문의 이력 조회 실패:', error);
      throw error;
    }
  },

  // 문의 상세 조회
  getInquiryDetail: async (
    inquiryId: string
  ): Promise<BaseResponse<InquiryData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_seller_inquiry_detail(inquiryId)
      );
      return response.data;
    } catch (error) {
      console.error('문의 상세 조회 실패:', error);
      throw error;
    }
  },
};

export default SellerInquiryService;
